import axios, { type AxiosInstance } from "axios"
import { getExhibitionHeader } from "../utils/exhibitionContext";

export interface ExhibitionStatistics {
  total_exhibitions: number
  active_exhibitions: number
  inactive_exhibitions: number
  upcoming_exhibitions: number
  ongoing_exhibitions: number
  past_exhibitions: number
  exhibitions_by_type: Record<string, number>
  monthly_statistics: Array<{
    month: string
    count: number
  }>
  total_exhibition_types: number
  // Lists
  active_exhibitions_list: Exhibition[]
  inactive_exhibitions_list: Exhibition[]
  upcoming_exhibitions_list: Exhibition[]
  ongoing_exhibitions_list: Exhibition[]
  past_exhibitions_list: Exhibition[]
}

export interface Exhibition {
  id: number
  title: string
  description?: string
  venue: string
  start_date: string
  end_date: string
  status: boolean
  exhibition_type: number
  exhibition_type_name: string
  created_at: string
  updated_at: string
}

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: {
    "Content-Type": "application/json",
  },
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    
    Object.assign(config.headers, getExhibitionHeader());}
    return config
  },
  (error) => Promise.reject(error),
)

export const ExhibitionStatisticsService = {
  // Get exhibition statistics with lists - single endpoint
  getStatistics: async (): Promise<ExhibitionStatistics> => {
    const response = await api.get("/api/exhibitions/statistics/")
    return response.data
  },

  // Get exhibition by ID (for view details)
  getById: async (id: number): Promise<Exhibition> => {
    const response = await api.get(`/api/exhibitions/${id}/`)
    return response.data
  },
}
